export const contentFactoryMap = {
  article: "article",
  contentCreator: "content-creator",
  videoContentCreator: "video-content-creator",
  reframer: "reframer",
};
